import { HtmlElementView } from './html-element-view.js';
import { DownloadDetailsView, DownloadDetailsContent } from './interfaces.js';

export class DownloadDetails extends HtmlElementView implements DownloadDetailsView {
  constructor(
    readonly section: HTMLElement,
    readonly fileName: HTMLSpanElement,
    readonly fileSize: HTMLSpanElement,
    readonly contentType: HTMLSpanElement,
    readonly downloadButton: HTMLButtonElement,
    private content: DownloadDetailsContent | null = null,
  ) {
    super(section);
    this.bindDownloadButton();
  }

  private bindDownloadButton() {
    this.downloadButton.addEventListener('click', async e => {
      e.preventDefault();
      try {
        this.downloadButton.disabled = true;
        await this.download();
      } finally {
        this.downloadButton.disabled = false;
      }
    });
  }

  private async download() {
    const content = this.content;
    if (!content) {
      throw new Error('Download content not set');
    }

    const {
      secureContents,
      fileName,
      contentType,
      downloadUrl,
    } = content;

    const response = await fetch(downloadUrl);
    const blob = await response.blob();

    const file = await secureContents.download({
      blob,
      fileName,
      contentType,
    });

    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  setContent(content: DownloadDetailsContent): void {
    this.fileName.textContent = content.fileName;
    this.fileSize.textContent = humanizeFileSize(content.fileSize);
    this.contentType.textContent = content.fileType;
    this.content = content;
  }
}

function humanizeFileSize(size: number): string {
  if (size < 1024) return `${size} B`;
  const units = ['KiB', 'MiB', 'GiB', 'TiB'];
  let unitIndex = -1;
  do {
    size /= 1024;
    unitIndex++;
  } while (size >= 1024 && unitIndex < units.length - 1);
  return `${size.toFixed(2)} ${units[unitIndex]}`;
}
